import { LayerItem } from 'libs/react-openlayers/src/lib/layerManagement/types';
import { MapBrowserEvent } from 'ol';
import Map from 'ol/Map';
import { HoverState } from '../../../../../libs/react-openlayers/src/lib/vectorTiles/useVectorTiles';
export const cursorMoveHandler = (
  evt: MapBrowserEvent<PointerEvent>,
  map: Map,
  canvas: HTMLCanvasElement | null,
  isDrawing: boolean
) => {
  const mapElement = map.getTargetElement();

  if (!mapElement) {
    console.warn('Map element not found');
    return;
  }

  const pixel = map.getPixelFromCoordinate(evt.coordinate);

  if (isDrawing) {
    mapElement.style.cursor = 'crosshair';
    return;
  }

  let isHoveringClickable = false;

  // Check if hovering over a clickable layer
  map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
    const isClickable = layer.get('properties')?.clickable;

    if (isClickable) {
      isHoveringClickable = true;
      return true; // Stop further checks
    }
  });

  // Update cursor style based on clickable layers
  if (isHoveringClickable) {
    mapElement.style.cursor = 'pointer';
    return;
  }

  // Color by canvas pixel, which will trigger when hovering a ship (the ships are on the canvas as an image)
  if (pixel && canvas) {
    const ctx = canvas.getContext('2d');
    if (ctx) {
      const imageData = ctx.getImageData(pixel[0], pixel[1], 1, 1).data;
      const isTransparent = imageData[3] === 0;
      mapElement.style.cursor = isTransparent ? 'grab' : 'pointer';
    }
  }
};

export const cursorDragHandler = (
  evt: MapBrowserEvent<PointerEvent>,
  map: Map
) => {
  map.getTargetElement().style.cursor = 'grabbing';
};

export const cursorUpHandler = (
  evt: MapBrowserEvent<PointerEvent>,
  map: Map,
  isDrawing: boolean
) => {
  const defaultCursor = isDrawing ? 'crosshair' : 'grab';
  map.getTargetElement().style.cursor = defaultCursor;
};

export const cursorVectorTileHover = (
  event: MapBrowserEvent<PointerEvent>,
  map: Map,
  vectorTileLayers: LayerItem[],
  onVectorTileHover: (state: HoverState) => void
): boolean => {
  let vectorTileFeatureFound = false;
  if (!vectorTileLayers.length) {
    return vectorTileFeatureFound;
  }

  const pixel = event.pixel;

  // Store previous cursor style to avoid unnecessary DOM updates
  const previousCursor = map.getTargetElement().style.cursor;

  // Use layerFilter to only check vector tile layers
  map.forEachFeatureAtPixel(
    pixel,
    (feature, layer) => {
      if (vectorTileLayers.some((item) => item.layer === layer)) {
        vectorTileFeatureFound = true;

        // Only update cursor if it's different
        if (previousCursor !== 'pointer') {
          map.getTargetElement().style.cursor = 'pointer';
        }

        onVectorTileHover({
          feature,
          position: {
            x: event.originalEvent.clientX,
            y: event.originalEvent.clientY,
          },
        });

        // Stop iteration once we find a feature
        return true;
      }
    },
    {
      hitTolerance: 2,
      layerFilter: (layer) =>
        vectorTileLayers.some((item) => item.layer === layer),
    }
  );

  if (!vectorTileFeatureFound) {
    // Only update cursor if it's different
    if (previousCursor !== '') {
      map.getTargetElement().style.cursor = '';
    }

    onVectorTileHover({
      feature: null,
      position: null,
    });
  }

  return vectorTileFeatureFound;
};
